<template>
  <div>
    <!-- 基本信息 -->
    <article v-show="!sessionShow && !contactShow && !contactEditShow" class="confirm-art">
      <group>
        <x-input :class="{'price-verify': verifyItem.minimum_price}" title="起拍价" v-model="minimum_price" placeholder="请输入">
          <span slot="right" style="color: #000;">万元</span>
        </x-input>
        <x-input :class="{'price-verify': verifyItem.reserve_price}" title="保留价" v-model="reserve_price" placeholder="请输入">
          <span slot="right" style="color: #000;">万元</span>
        </x-input>

        <selector title="加价幅度" v-model.number="quote_increment" :options="incrementList"></selector>
      </group>

      <group>
        <div class="contact">
          <label class="weui_label">看车联系人</label>
          <div class="contact__content" @click="handleSelectContact">
            <p v-if="contactMsg" class="contact__value">{{ contactMsg }}</p>
            <p v-else class="contact__placeholder">请添加联系人</p>
          </div>
        </div>
      </group>

      <group>
        <div class="session-detail">
          <div class="pd30">
            <div class="session-detail__label">
              <label class="weui_label">开拍场次</label>
              <div class="session-detail__content" @click="toSessionList()">
                <div v-if="auctionSession.id" class="session-detail__value">{{ auctionSession.name }}</div>
                <div v-else class="session-detail__placeholder">请选择开拍场次</div>
              </div>
            </div>
          </div>

          <!-- 每一场次信息 -->
          <div v-if="auctionSession.id" class="session-item-wrap">
            <div class="session-line vux-1px-b"></div>
            <div class="session-item-pd">
              <div class="session-item-info">
                <div class="session-item__title">
                  {{auctionSession.name}}
                </div>
                <div class="session-item__message">
                  <div class="session-item__message-item">
                    {{auctionSession.start_date ? auctionSession.start_date.replace(/-/g,"."):''}} {{auctionSession.start_at}} | {{ auctionSession.cars }}辆
                  </div>
                  <div class="session-item__message-item">
                    保证金：{{ auctionSession.frozen_amount | transformMoney }}元/辆 信息服务费：{{ auctionSession.commission_amount | transformMoney }}元/辆
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 每一场次信息 -->
        </div>

      </group>

      <group class="vin-control">
        <x-switch title="对车商公开此车辆VIN码及出厂铭牌" v-model="car_vin_show_switch"></x-switch>
      </group>

      <p class="protocol-hint">
        <span>提交拍卖即代表阅读并同意</span>
        <router-link to="/protocol/auction">拍卖协议</router-link>
      </p>

      <!-- <h2 class="tip-sub" v-if="session.name">提示：{{session.name}}，已排有{{session.auction_count}}台车</h2> -->
      <div class="btn-bottom">
        <div class="btn-fix">
          <x-button class="btn" @click.native="toSave()">确认提交</x-button>
        </div>
      </div>
    </article>
    <!-- 基本信息 -->

    <!-- 选择联系人 -->
    <article v-if="contactShow" class="session-list">
      <contact-list :contactList.sync="contactList" :selectId.sync="selectContractId" @onSelect="handleConfirmContact"></contact-list>
    </article>
    <!-- 选择联系人 -->

    <!-- 新增联系人 -->
    <article v-if="contactEditShow" class="session-list">
      <contact-edit @onConfirm="handleConfirmAddContact"></contact-edit>
    </article>
    <!-- 新增联系人 -->

    <!-- 场次信息 -->
    <article  v-if="sessionShow" class="session-list">
      <group class="session-time">
        <datetime @on-change="dateChange" class="time-picker" v-model="auction_date" confirm-text="完成" cancel-text="取消" :min-year=1970 format="YYYY-MM-DD" :start-date="startDate" placeholder="请选择开拍日期" title="开拍日期"></datetime>
      </group>

      <group :key="index" v-for="(item,index) of auctions">
        <!-- 每一场次信息 -->
        <div class="session-item-wrap">
          <div class="session-item-pd">
            <div class="session-item-checkbox radio">
              <input  @click="radioClick(item,$event)" v-model="currentSessionId" :id="getRadioId(index)" :value="item.id" name="radio" type="radio">
              <label :for="getRadioId(index)" class="radio-label"></label>
            </div>

            <div @click="selectAuctions(item)" class="session-item-info">
              <div class="session-item-title">
                {{item.name}}
              </div>
              <div class="session-item-meta">
                <div class="session-item-time session-fl">
                  <i class="time-icon session-fl"></i>
                  {{item.start_at}}场
                </div>
                <div class="session-item-count session-fl">
                  <i class="car-icon session-fl"></i>
                  已排{{item.cars}}台车
                </div>
              </div>
            </div>
          </div>

          <!-- 1px线 -->
          <div class="session-line vux-1px-b"></div>
          <!-- 1px线 -->
          <!-- 参与城市 -->
          <city
            :frozenAmount="item.frozen_amount"
            :commissionAmount="item.commission_amount">
          </city>
          <!-- 参与城市 -->
        </div>
        <!-- 每一场次信息 -->
      </group>

    </article>
    <!-- 场次信息 -->
    <!-- 价格提醒 begin-->
    <x-alert v-model="dialogShow" button-text="我知道了" title="金额防错提示" class="verify-dialog">
      <h4 class="tips">当前的单位为“万元”，你所输入的以下金额大于100万元，请确认金额输入是否正确。</h4>
      <p v-for="(item, index) in dialogContent" :key="index">{{item}}</p>
    </x-alert>
    <!-- 价格提醒 end -->
  </div>
</template>
<script>
// 提交拍卖
import {
  Selector,
  XButton,
  XInput,
  Group,
  Datetime,
  XAlert,
  XSwitch
} from '@lx-frontend/cvux'
import City from '../components/city'
import ContactList from './components/ContactList'
import ContactEdit from './components/ContactEdit'
import util from '../../common/util'
import cache from '../../common/cache'

export default {
  components: {
    Selector,
    XButton,
    XInput,
    Group,
    Datetime,
    City,
    XAlert,
    XSwitch,
    ContactList,
    ContactEdit
  },
  data() {
    return {
      dialogShow: false,
      isVerify: true, // 是否执行金额验证
      verifyItem: {
        minimum_price: false,
        reserve_price: false
      },
      dialogContent: [], // 提示文本
      auctionId: '',
      // 日期选择器的开始
      startDate: '', // 日期选择器的开始
      auction_date: '', // 场次时间
      sessionKey: 'AUCTION_CONFIRMED',
      minimum_price: null,
      reserve_price: null,
      quote_increment: 10000, // 加价幅度 v1.4新增
      contact_name: '',
      contact_number: '',
      car_vin_show_switch: true, // 对车商公开车辆vin和出厂铭牌
      session: {},
      // 超过多少行，省略号
      heightAuto: false,
      // 旋转角度
      degNum: 0,
      documentTitleCache: '', // 页面title
      contactList: [], // 联系人列表
      selectContractId: 0, // 联系人Id
      contactShow: false, // 显示联系人列表
      contactEditShow: false, // 显示编辑联系人
      sessionShow: false, // 场次列表是否显示
      picked: '',
      auctionSession: {}, // 选中场次详细信息
      currentSessionId: '', // 选中的当前场次
      auctions: [], // 场次列表
      // 加价幅度列表
      incrementList: [
        {
          key: 10000,
          value: '100元'
        },
        {
          key: 20000,
          value: '200元'
        },
        {
          key: 50000,
          value: '500元'
        },
        {
          key: 100000,
          value: '1000元'
        }
      ]
    }
  },
  created() {
    this.auctionId = this.$route.params.id
    if (this.auctionId) {
      this.$rest.auction
        .getCommitedAuctionInfo({}, this.auctionId)
        .then(res => {
          if (res.code === 0) {
            if (res.data) {
              this.auctionSession = res.data.session
              this.auction_date = res.data.auction_date || ''
              this.selectContractId = res.data.contact_id || 0
              this.contact_name = res.data.contact_name || ''
              this.contact_number = res.data.contact_number || ''
              this.reserve_price = res.data.reserve_price
                ? res.data.reserve_price / 1000000
                : null
              this.minimum_price = res.data.minimum_price
                ? res.data.minimum_price / 1000000
                : null
              // 加价幅度 v1.4新增
              this.quote_increment = res.data.quote_increment ? +res.data.quote_increment : 10000
              this.initSessionData()
              this.fetchContactList()
            } else {
              // 初始化场次信息数据
              this.initSessionData()
              this.fetchContactList()
            }
          }
        })
    }
  },
  methods: {
    // toWatchAction() {
    //   if (this.order && this.auction_date) {
    //     this.$rest.auction
    //       .getAuctionSessions({
    //         auction_datetime: this.auction_date + '' + this.order
    //       })
    //       .then(res => {
    //         if (res.code === 0) {
    //           // 判断每场次限20辆车
    //           if (res.data.auction_count > 19) {
    //             this.session = {
    //               name: res.data.name,
    //               auction_count: res.data.auction_count,
    //               auction_other: '请选择其它场次车辆'
    //             }
    //           }
    //         } else if (res.code === 404) {
    //           this.session = {
    //             name: this.auction_date,
    //             auction_count: '0',
    //             auction_other: ''
    //           }
    //         }
    //       })
    //   }
    // },
    toSave() {
      if (this.auctionId) {
        let minimumPrice = this.minimum_price
        let reservePrice = this.reserve_price
        let auctionDate = this.auctionSession.auction_date || this.auction_date
        let sessionId = this.auctionSession.id
        let quoteIncrement = this.quote_increment
        let reg = /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
        if (
          minimumPrice.length > 7 ||
          minimumPrice > 10000 ||
          !reg.test(minimumPrice)
        ) {
          this.showToast('起拍价最多支持4位整数和2位小数')
          return false
        }
        if (
          reservePrice.length > 7 ||
          reservePrice > 10000 ||
          !reg.test(reservePrice)
        ) {
          this.showToast('保留价最多支持4位整数和2位小数')
          return false
        }
        if (
          reservePrice &&
          minimumPrice &&
          Number.parseInt(reservePrice) < Number.parseInt(minimumPrice)
        ) {
          this.showToast('保留价必须大于或等于起拍价')
          return false
        }

        // 加价幅度条件判断
        if (!quoteIncrement) {
          this.showToast('请选择加价幅度')
          return false
        }

        if (!this.contactMsg) {
          this.showToast('请设置联系人')
          return false
        }

        if (!auctionDate) {
          this.showToast('请选择开拍场次')
          return false
        }

        if (this.isVerify) {
          const ispass = this.priceVerify()
          if (!ispass) {
            return false
          }
        }

        const contactSelected = this.contactList.find((item) => {
          return item.id === this.selectContractId
        })

        const params = {
          minimum_price: Math.round(Number.parseFloat(minimumPrice) * 1000000),
          reserve_price: Math.round(Number.parseFloat(reservePrice) * 1000000),
          auction_date: auctionDate,
          contact_id: this.selectContractId,
          contact_name: contactSelected.contact_name,
          contact_number: contactSelected.contact_number,
          session_id: sessionId,
          quote_increment: quoteIncrement,
          car_vin_show_switch: this.car_vin_show_switch
        }
        return this.$rest.auction.commitAuctionRequest(params, this.auctionId)
          .then(res => {
            if (res.code === 0) {
              cache.setSessionData(this.sessionKey, res.data)
              this.$router.push({ path: '/auction/carmanage/confirmed' })
            } else {
              this.showToast(res.message)
            }
          })
      }
    },
    // 金额防错提示
    priceVerify() {
      if (this.minimum_price > 100) {
        this.verifyItem.minimum_price = true
        this.dialogContent.push(`起拍价：${this.minimum_price}万元`)
      }
      if (this.reserve_price > 100) {
        this.verifyItem.reserve_price = true
        this.dialogContent.push(`保留价：${this.reserve_price}万元`)
      }
      if (this.dialogContent.length > 0) {
        this.dialogShow = true
        this.isVerify = false
        return false
      }
      return true
    },
    // 拉取联系人列表
    fetchContactList() {
      this.$rest.auction.getContactList()
        .then((res) => {
          if (res.code === 0) {
            const contactList = res.data.contacts
            this.contactList = contactList
            if (contactList.length) {
              const defaultContact = contactList.find((item) => {
                return item.is_default_contact
              })
              this.selectContractId = defaultContact ? this.selectContractId || defaultContact.id : this.selectContractId || contactList[0].id
            }
          } else {
            this.showToast(res.message)
          }
        })
    },
    // 选择联系人
    handleSelectContact() {
      this.documentTitleCache = document.title
      if (this.contactList.length) {
        document.title = '选择联系人'
        this.contactShow = true
      } else {
        document.title = '添加联系人'
        this.contactEditShow = true
      }
    },
    // 确认选择联系人回调
    handleConfirmContact() {
      document.title = this.documentTitleCache
      this.contactShow = false
    },
    // 确认添加联系人回调
    handleConfirmAddContact(id) {
      document.title = this.documentTitleCache
      this.selectContractId = id
      this.fetchContactList()
      this.contactEditShow = false
    },
    toSessionList() {
      this.sessionShow = !this.sessionShow
    },
    toggleCities() {
      // 切换显示场次城市列表，2行
      this.heightAuto = !this.heightAuto
      this.degNum = this.degNum === 0 ? 180 : 0
    },
    // 初始化场次的数据
    initSessionData() {
      let nextDay = new Date()
      let today = new Date()
      nextDay.setTime(new Date().getTime() + 24 * 60 * 60 * 1000)
      let nextDayStr = util.formatTime(nextDay.getTime(), 'yyyy-MM-dd')
      let todayStr = util.formatTime(today.getTime(), 'yyyy-MM-dd')
      this.startDate = todayStr
      this.auction_date = this.auction_date || nextDayStr
      this.getAuctionsSessions(this.auction_date)
    },
    // 获取后端场次数据列表
    getAuctionsSessions(auctionDate) {
      this.$rest.auction.getAuctionSessionsList({
        start_date: auctionDate
      }).then(res => {
        if (res.code === 0) {
          this.auctions = res.data
        } else {
          this.showToast('请选中场次')
        }
      })
    },
    // 场次日期切换事件
    dateChange(val) {
      this.getAuctionsSessions(val)
    },
    // 场次单选框唯一id
    getRadioId: function (index) {
      return 'radio-' + index
    },
    // 场次点击事件
    selectAuctions(item) {
      item.auction_date = this.auction_date
      this.currentSessionId = item.id
      // 点击的场次信息存起来
      this.auctionSession = item
      this.toSessionList()
    },
    // 场次单选框绑定事件
    radioClick(item, $event) {
      this.selectAuctions(item)
    }
  },
  computed: {
    contactMsg() {
      if (!this.contactList.length) {
        return ''
      }
      const contact = this.contactList.find((item) => {
        return item.id === this.selectContractId
      })
      return contact ? `${contact.contact_name}|${contact.contact_number}` : `${this.contactList[0].contact_name}|${this.contactList[0].contact_number}`
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
@import '../../stylesheets/modules/manage/input.less';
@import '../../stylesheets/modules/auction/sessionList.less';
@import '../../stylesheets/base/mixin/common.less';
@import '~@lx-frontend/cvux/src/styles/common/1px.less';

.pd30 {
  padding: 30/@w2;
}

.confirm-art {
  padding-bottom: 30/@w2;
  .remark textarea {
    font-size: 30/@w2;
  }
  .remark.weui_cell {
    align-items: flex-start;
  }

  .remark .weui_cell {
    padding: 0;
  }

  .remark .weui_label {
    width: 180/@w2 !important;
    display: inline-block;
  }
  .btn {
    background-color: #3b5999;
    border-radius: 0;
    color: #fff;
  }
  .vin-control .weui_label {
    width: 100% !important;
  }

  .protocol-hint {
    padding: 20/@w2 30/@w2;
    font-size: 0;
    a, span {
      font-size: 26/@w2;
    }
    a {
      color:#3b5999;
    }
  }
}

.tip-sub {
  line-height: 44/@w2;
  padding-left: 30/@w2;
  padding-top: 20/@w2;
  font-size: 26/@w2;
  opacity: 0.7;
}

.session-detail {
  width: 100%;
  &__label {
    display: flex;
  }
  &__content {
    flex-grow: 1;
    position: relative;
    &:after {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      content: ' ';
      width: 26/@w2;
      height: 26/@w2;
      background-size: cover;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAABFklEQVRIS8XW0W3CMBAG4DvXAzACI3SEjsAI4RmBCGGADgAYgXiGDQgT0A3aTtBJ6h+dWr8gkthnAXl29PmPz3dhesDDTcZqtamZX97LcvSVu49GZLncFES8Nsa85UKNiOw+QESYVtXkoE3UigSImfcAhlqoExFosdgOmOmgTRSFCOTc7tV7/6GBopEcKAm5go5VNRnGFEMyooFUyB/k+t7bmgifXYnUyD/U895KMbRCWUhIBNiftnuUhTjneoA9E9H3bDYumopAjciZAPbYBQisQuRiAr9nIj61JQjJkpFUIDlJAAAqU5pldBItEJ1EurAx2KcmiD4TGVx3nSdhMgJUzOfjOqYZ3lrz3Bn/kL8V7ae59d4FxNGvGvN4ydkAAAAASUVORK5CYII=)
    }
  }
  &__placeholder {
    font-size: 30/@w2;
    color: #999999;
  }
  &__value {
    font-size: 30/@w2;
  }
}
.session-item__title {
  font-size: 30/@w2;
  line-height: 42/@w2;
  color: #333333;
  margin-bottom: 12/@w2;
}
.session-item__message {
  font-size: 26/@w2;
  line-height: 37/@w2;
  color: rgba(51, 51, 51, 0.7);
}
.session-item__message-item {
  margin-bottom: 12/@w2;
}
.contact {
  padding: 30/@w2;
  display: flex;
  &__content {
    flex-grow: 1;
    position: relative;
    &:after {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      content: ' ';
      width: 26/@w2;
      height: 26/@w2;
      background-size: cover;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAABFklEQVRIS8XW0W3CMBAG4DvXAzACI3SEjsAI4RmBCGGADgAYgXiGDQgT0A3aTtBJ6h+dWr8gkthnAXl29PmPz3dhesDDTcZqtamZX97LcvSVu49GZLncFES8Nsa85UKNiOw+QESYVtXkoE3UigSImfcAhlqoExFosdgOmOmgTRSFCOTc7tV7/6GBopEcKAm5go5VNRnGFEMyooFUyB/k+t7bmgifXYnUyD/U895KMbRCWUhIBNiftnuUhTjneoA9E9H3bDYumopAjciZAPbYBQisQuRiAr9nIj61JQjJkpFUIDlJAAAqU5pldBItEJ1EurAx2KcmiD4TGVx3nSdhMgJUzOfjOqYZ3lrz3Bn/kL8V7ae59d4FxNGvGvN4ydkAAAAASUVORK5CYII=)
    }
  }
  &__placeholder {
    font-size: 30/@w2;
    color: #999999;
  }
  &__value {
    font-size: 30/@w2;
  }
}
</style>
